document.addEventListener("DOMContentLoaded", () => {

    const header = document.querySelector("header");
    const header_h = header ? header.offsetHeight : 0;

    const isMobile = window.innerWidth < 960;

    // Target container based on screen size
    const targetContainer = isMobile 
        ? document.querySelector(".before-single-blog-content") 
        : document.querySelector(".left-single-blog-content");

    if (!targetContainer) return;

    // Insert TOC wrapper
    targetContainer.innerHTML = `
        <div id="toc_content">
            <h4>In this article</h4>
            <ol class="toc"></ol>
        </div>
    `;

    const tocList = document.querySelector("#toc_content .toc");

    // Loop through all H2 headings
    document.querySelectorAll(".article-template__content h2").forEach((h2, index) => {
        const headingId = "heading_h2_" + index;
        h2.id = headingId;

        const li = document.createElement("li");
        li.innerHTML = `<a href="#${headingId}">${h2.textContent}</a>`;
        tocList.appendChild(li);
    });

    // Smooth scroll to headings
    document.querySelectorAll("#toc_content a").forEach(a => {
        a.addEventListener("click", (e) => {
            e.preventDefault();
            const target = document.querySelector(a.getAttribute("href"));
            if (!target) return;

            const position = target.offsetTop - header_h;

            window.scrollTo({
                top: position,
                behavior: "smooth"
            });
        });
    });

});
